<template>
	<div>
		<el-config-provider :locale="lang=='zh-cn'?lang_cn:lang_en">
			<router-view/>

			<el-dialog v-model="showVersionDlg" title="版本更新" width="30%">
				<el-descriptions :column="2" border direction="vertical">
					<el-descriptions-item label="版本号">{{versionInfo.VersionNo}}</el-descriptions-item>
					<el-descriptions-item label="时间">{{versionInfo.CreateTime}}</el-descriptions-item>
					<el-descriptions-item label="更新内容" :span="2">{{versionInfo.Describe}}</el-descriptions-item>
				</el-descriptions>
			</el-dialog>			
		</el-config-provider>
	</div>
</template>

<script>
import request_v from '@/api/request_v'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
export default {
	name: '',
    props:{},
    components:{},
    data(){
        return{
			showVersionDlg:false,
			versionInfo:{},

			lang_cn: zhCn,
			lang_en: en,
        }
    },
    computed:{       
		env(){
			return process.env.NODE_ENV
		},
		windowWidth(){
			return this.$store.state.windowWidth;
		},
		windowHeight(){
			return this.$store.state.windowHeight;
		},
		lang(){
			return this.$store.state.lang;
		}
	},
    watch:{},
    created(){		
		// console.log(process.env.NODE_ENV);
		console.log(window.location.href);
		if (window.location.href.includes('192.168.11.59:803') || window.location.href.includes('kuos')){
				this.$store.commit("setLang", 'en');
		} else {
				this.$store.commit("setLang", 'zh-cn');
		}
		// // 测试
		// this.$store.commit("setLang", 'en');

		
		this.checkVersion1();
		// 在页面加载时读取sessionStorage里的状态信息
		if (sessionStorage.getItem('store')) {
			this.$store.replaceState(
				Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store')))
			)
			var tokens = JSON.parse(sessionStorage.getItem('tokens'))
			tokens.forEach(el => {
				this.$store.commit("addTokens",{ time:el.k, token:el.t });
			})
			// console.log(this.$store.state);
			sessionStorage.removeItem('store')
			sessionStorage.removeItem('tokens')
		}
		
		// 在页面刷新时将vuex里的信息保存到sessionStorage里
		// beforeunload事件在页面刷新时先触发
		window.addEventListener('beforeunload', () => {
			// console.log(this.$store.state);
			sessionStorage.setItem('store', JSON.stringify(this.$store.state))	
			var tokens = []		
			for (var key in this.$store.state.tokens){
				tokens.push({k:key,t:this.$store.state.tokens[key]});
			}
			sessionStorage.setItem('tokens', JSON.stringify(tokens))	
		})

		this.getWindowExtent();

		var l = localStorage.getItem('Language')				
		if (l) this.$store.commit("setLang", l);
	},
    mounted(){
		var favicon = document.querySelector('link[rel="icon"]');
		if (this.env =='zhj'){
			document.title = "智绘佳订单管理系统"
			// favicon.href = '/favicon_tg.ico'
			favicon.href = '/facvion_zhj.ico'
		} else {
			document.title = this.$t("科凡全屋定制订单管理系统")
			favicon.href = '/favicon.ico'
		}
		// console.log(favicon);
	},
    methods:{			
		getWindowExtent(){
			var that = this;
			// console.log(window.innerWidth,window.innerHeight);
			if (this.windowWidth  != window.innerWidth ) this.$store.commit("setWindowWidth", window.innerWidth );
			if (this.windowHeight != window.innerHeight) this.$store.commit("setWindowHeight",window.innerHeight);
			setTimeout(that.getWindowExtent,100)
		},
		checkVersion(){
			var that = this;
			console.log(process.env.VUE_APP_VERSION);
			request_v({
                url:'GetLastCrmVersion',
                method:'GET',
            }).then(({res,headers}) => {
				// console.log(res);
				// console.log(res.data);
				var updateLastVersion = localStorage.getItem('UpdateLastVersion');
				if (process.env.VUE_APP_VERSION != res.data.VersionNo){
					switch (updateLastVersion) {
						case "2":
							that.$message({
								type:'error',
								message:"系统更新失败！请按住键盘上的‘Ctrl’键，鼠标左键点击浏览器左上角的刷新按钮强制更新！",
								duration:0
							})							
							break;
						case "1":
							res.data.CreateTime = res.data.CreateTime.replace('T',' ').split('.')[0];
							localStorage.setItem('UpdateLastVersion','2');
							window.location.href = window.location.href.split('?')[0];
							break;
						default:
							res.data.CreateTime = res.data.CreateTime.replace('T',' ').split('.')[0];
							localStorage.setItem('UpdateLastVersion','1');
							location.reload(true);
							break;
					}
				} else {
					if (updateLastVersion){
						that.versionInfo = res.data;
						that.showVersionDlg = true;
						localStorage.removeItem('UpdateLastVersion')
					}
				}
            }).catch( err => {
                console.log(err);
                this.$message.error(err.message)
            }).finally(() =>{
                // that.isTableLoading=false;
            })
		},
		checkVersion1(){
			var updateLastVersion = localStorage.getItem('LastVersion');
			if (updateLastVersion != process.env.VUE_APP_VERSION){
				var that = this;
				request_v({
					url:'GetLastCrmVersion',
					method:'GET',
				}).then(({res,headers}) => {
					// console.log(res);
					// console.log(res.data);
					that.versionInfo = res.data;
					that.showVersionDlg = true;
					localStorage.setItem('LastVersion',process.env.VUE_APP_VERSION);
				}).catch( err => {
					console.log(err);
					this.$message.error(err.message)
				}).finally(() =>{
					// that.isTableLoading=false;
				})
			}
		}
    },
}
</script>

<style>
#app {
	font-family: "思源黑体 CN Medium", "Dongfang-Dakai", Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

nav {
	padding: 30px;
}

nav a {
	font-weight: bold;
	color: #2c3e50;
}

nav a.router-link-exact-active {
	color: #42b983;
}

body{
	margin: 0px !important;
}

:root{
	--main_colour:cornflowerblue;
	--main_colour_1:rgba(100, 148, 237, 0.801);
	--main_colour_2:rgba(100, 148, 237, 0.226);
	--main_colour_3:rgba(100, 148, 237, 0.05);

	--sub_colour:white;
	--sub_colour_1:white;
	--sub_colour_2:white;

	--text_colour_1:white;
	--text_colour_2:black;

	--row_bg:#8bc34a29;
	--el-table-current-row-bg-color:#8bc34a29;

	--button_font_size_0: 17px;
}


/* .lightsys .el-dialog__header{
    border-bottom: 1px solid #ccc;
}
.lightsys .el-dialog__body{
    padding: 0px;
} */
.el-checkbox-button.is-checked.btn_primary{
    color: #fff;
    --el-checkbox-button-checked-bg-color: var(--el-color-primary) !important;
    --el-checkbox-button-checked-border-color: var(--el-color-primary) !important;
}
.el-checkbox-button.is-checked.btn_success{
    color: #fff !important;
    --el-checkbox-button-checked-bg-color: var(--el-color-success) !important;
    --el-checkbox-button-checked-border-color: var(--el-color-success) !important;
}
.el-checkbox-button.is-checked.btn_info{
    color: #fff;
    --el-checkbox-button-checked-bg-color: var(--el-color-info) !important;
    --el-checkbox-button-checked-border-color: var(--el-color-info) !important;
}
.el-checkbox-button.is-checked.btn_warning{
    color: #fff;
    --el-checkbox-button-checked-bg-color: var(--el-color-warning) !important;
    --el-checkbox-button-checked-border-color: var(--el-color-warning) !important;
}
.el-checkbox-button.is-checked.btn_danger{
    color: #fff;
    --el-checkbox-button-checked-bg-color: var(--el-color-danger) !important;
    --el-checkbox-button-checked-border-color: var(--el-color-danger) !important;
}

.el-tag__content{	
    display: flex;
    align-items: flex-end;
	gap: 2px;
}

.el-scrollbar__bar.is-horizontal{
	height: 10px !important;
}
.el-scrollbar__bar.is-vertical {
	width: 10px !important;
}
</style>
